import { ApiResponse } from 'apisauce';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';
import { IExtubation, IHypotension, IResponse, IResponseSnapshot } from '../../models';
import { TPostExtubationResult, TPostHypotensionResult } from './CdssTypes';

/**
 * # Cdss Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new CdssApi();
 *
 * ```
 */
export class CdssApi {
  private api: Api;

  private BASE_URL = '/cdss';

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  async uploadAndGetExtubation(file: File): Promise<TPostExtubationResult> {
    try {
      const url = `${this.BASE_URL}/extubation`;
      const formData = new FormData();
      formData.append('file', file);
      const response: ApiResponse<any> = await this.api.apisauce.post(url, formData);
      const extubation: IExtubation = response.data;
      if (!response.ok && !extubation) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      return { kind: 'ok', extubation };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async uploadAndGetHypotension(file: File): Promise<TPostHypotensionResult> {
    try {
      const url = `${this.BASE_URL}/hypotension`;
      const formData = new FormData();
      formData.append('file', file);
      const response: ApiResponse<any> = await this.api.apisauce.post(url, formData);
      const hypotensions: IHypotension[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      if (!response.ok && !hypotensions) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      return { kind: 'ok', hypotensions, responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
